export var AgfNielsenBrowserSdkEvents = /*#__PURE__*/ function(AgfNielsenBrowserSdkEvents) {
    AgfNielsenBrowserSdkEvents["LOAD_METADATA"] = "loadMetadata";
    AgfNielsenBrowserSdkEvents["SET_PLAYHEAD_POSITION"] = "setPlayheadPosition";
    AgfNielsenBrowserSdkEvents["STOP"] = "stop";
    AgfNielsenBrowserSdkEvents["END"] = "end";
    return AgfNielsenBrowserSdkEvents;
}({});
export var DomlessNielsenSdkEvents = /*#__PURE__*/ function(DomlessNielsenSdkEvents) {
    DomlessNielsenSdkEvents["LOAD_METADATA"] = "loadmetadata";
    DomlessNielsenSdkEvents["SET_PLAYHEAD_POSITION"] = "setplayheadposition";
    DomlessNielsenSdkEvents["STOP"] = "stop";
    DomlessNielsenSdkEvents["END"] = "end";
    return DomlessNielsenSdkEvents;
}({});

//# sourceMappingURL=agf-nielsen.enums.js.map